import React, { memo, useEffect } from 'react';
import { Heading, HStack, Image, Text, VStack } from 'native-base';
const Congratulations = props => {
  const {
    title,
    description
  } = props;
  useEffect(() => {
    if (props !== null && props !== void 0 && props.setConfettiExplosion) {
      props === null || props === void 0 || props.setConfettiExplosion();
    }
  }, [props]);
  return /*#__PURE__*/React.createElement(HStack, {
    rounded: "xl",
    bg: "#ECF0F3",
    height: 300,
    width: "100%",
    borderWidth: 1,
    borderRadius: "4",
    borderColor: "black.300",
    testID: "congratulations-root",
    backgroundColor: "navyblue.900"
  }, /*#__PURE__*/React.createElement(Image, {
    accessibilityLabel: "confetti on the left side",
    testID: "congratulations confetti left",
    source: {
      uri: 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/b9c44c44-1614-4959-bc45-2fa22b38cd66/renditions/0aab8a0c-d4a2-404a-ab81-aa1e6c3b7eaa?binary=true'
    },
    width: {
      base: '5%',
      md: '20%',
      lg: '28%'
    },
    height: "100%",
    backgroundColor: "transparent",
    alt: "confetti-image-left",
    opacity: {
      base: '50',
      md: '100',
      lg: '100'
    }
  }), /*#__PURE__*/React.createElement(VStack, {
    textAlign: "center",
    width: {
      base: '90%',
      md: '60%',
      lg: '39%'
    },
    justifyContent: "center",
    alignItems: "center",
    flex: "1"
  }, /*#__PURE__*/React.createElement(Heading, {
    color: "text.running",
    textAlign: "center",
    accessibilityLabel: title,
    testID: `title-${title}`,
    fontFamily: "body",
    fontSize: "3xl",
    fontWeight: "normal",
    mx: "3"
  }, title), /*#__PURE__*/React.createElement(Text, {
    textAlign: "center",
    accessibilityLabel: description,
    testID: `description-${description}`,
    fontFamily: "body",
    fontSize: "sm",
    fontWeight: "normal"
  }, description)), /*#__PURE__*/React.createElement(Image, {
    source: {
      uri: 'https://dam.freedommortgage.com/dx/api/dam/v1/collections/563a2e94-abdb-4eda-a407-49cc1380b6f4/items/b9c44c44-1614-4959-bc45-2fa22b38cd66/renditions/0aab8a0c-d4a2-404a-ab81-aa1e6c3b7eaa?binary=true'
    },
    width: {
      base: '5%',
      md: '20%',
      lg: '28%'
    },
    height: "100%",
    alt: "confetti-image-right",
    style: {
      transform: [{
        rotate: '180deg'
      }]
    },
    opacity: {
      base: '50',
      md: '100',
      lg: '100'
    },
    accessibilityLabel: "confetti on the right side",
    testID: "congratulations confetti right"
  }));
};
export default /*#__PURE__*/memo(Congratulations);
//# sourceMappingURL=index.js.map